import React from "react";
import classes from "./styles/style.module.css";
import LogoContainer from "../../assets/images/rb/rb-logo-container.png";
import Logo from "../../assets/images/rb/rb-logo.png";
import { motion } from "framer-motion";

const RBPageCotainer = ({ children }) => {
  return (
    <div className={classes.rbPageContainer}>
      <div className={classes.animateBg}></div>
      <div className={classes.mainContainer}>
        <div className={classes.rbHeader}>
          <img
            src={LogoContainer}
            alt="rb-bg-container"
            className={classes.headerBgImg}
          />
          <motion.div
            className={classes.rbLogoContainer}
            initial={{ opacity: 0, y: -80 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.7 }}
          >
            <img src={Logo} alt="rb-logo" />
          </motion.div>
        </div>
        {/* menu Container */}
        {children}
      </div>
    </div>
  );
};

export default RBPageCotainer;
